// extracted by mini-css-extract-plugin
export default {"root":"EmailTemplatesPopover_root__4nrAK","paper":"EmailTemplatesPopover_paper__IUpWT"};